export default {
	messages: {
		general: {
			no_alerts: "Nenhum alerta encontrado",
			no_attachments: "Parece que você está com falta de anexos",
			drop_files_here: "Solte seu arquivo(s) aqui",
			no_values_for_this_date: "Nenhum valor encontrado para esta data",
		}
	}
}



// WEBPACK FOOTER //
// ./src/i18n/messages/messages_pt.js